module.exports = __webpack_public_path__ + "img/poziom8.c98d9926.svg";